(ns frontend.view.reports.custom.db
  (:require [reagent.core :as r]
            [frontend.db :as app-db]))

(defonce deals-per-tag-status-and-stage (r/cursor app-db/app-state [:report :custom :deals-per-tag-status-and-stage]))
(defonce deals-throughput (r/cursor app-db/app-state [:report :custom :deals-throughput]))
(defonce chop (r/cursor app-db/app-state [:report :custom :chop]))
